export const PLUM = '#1B3A5C'
export const PLUM_DEEP = '#0E2440'
export const VIOLET = '#2F6FB0'
export const VIOLET_SOFT = '#5C93C9'
export const ACCENT = '#8FA6BF'
export const PARCHMENT = '#F7F3EC'
export const INK = '#1B1420'
export const WHITE = '#FFFFFF'

// Back-compat aliases used throughout older components
export const BLUE = VIOLET
export const RED = VIOLET_SOFT
export const LIGHT_BLUE = PARCHMENT

export const BLUE_PERCENT = percentage => `rgba(47,111,176,${percentage})`
export const RED_PERCENT = percentage => `rgba(92,147,201,${percentage})`
export const PLUM_PERCENT = percentage => `rgba(27,58,92,${percentage})`
